module.exports = __webpack_public_path__ + "static/img/bookonline.df6d2fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bookonline.jpg
// module id = 94
// module chunks = 1